import * as React from 'react';
import { cn } from '@/core/lib/utils';

const Container = React.forwardRef<HTMLDivElement, React.ComponentProps<'div'>>(
  ({ className, ...props }, ref) => {
    return (
      <div
        className={cn(
          'mx-auto max-w-full w-[calc(1126px+2rem)] min-h-[calc(100vh-100px)] px-[1rem] gap-4',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);

export { Container };
